<div class="row justify-content-between">
    <!-- search component start here -->
    <div class="col-md-12">
        <app-auto-suggestion-search></app-auto-suggestion-search>
        <!-- <app-search></app-search> -->
    </div>

    <!-- search components end here -->
    <div class="col-md-6">
        <div class="card carousel-card">
            <div class="card-body">
                <h3 class="card-title">I want to...</h3>
            </div>
            <div id="wantToCarousel" class="carousel slide pointer-event" data-ride="carousel" data-interval="false">
                <div class="carousel-inner">
                    <ng-container *ngFor="let product of product_chunk; let i = index">
                        <div [ngClass]="i===0 ? 'active carousel-item': 'carousel-item' ">
                            <ul class="list-group list-group-flush">
                                <li class="list-group-item" *ngFor="let item of product;let j = index">
                                    <ng-container *ngIf="item.link_url?.indexOf('/')==0">
                                        <a [routerLink]="[item.link_url]" [ngClass]="j==0? 'active': '' "
                                            target="_blank">
                                            <img [src]="item.icon_image" alt="">{{item.link_name}}
                                        </a>
                                    </ng-container>
                                    <ng-container *ngIf="item.link_url?.indexOf('/')!=0">
                                        <a href="{{item.link_url}}" [ngClass]="j==0? 'active': '' " target="_blank">
                                            <img [src]="item.icon_image" alt="">{{item.link_name}}
                                        </a>
                                    </ng-container>
                                </li>

                            </ul>
                        </div>
                    </ng-container>
                </div>

                <div class="carosel-arrows">
                    <a class="carousel-control-prev" href="#wantToCarousel" role="button" data-slide="prev">
                        
                        <img src="../../../assets/images/arrow-left.png" alt="" width="10" height="15">
                    </a>
                    <a class="carousel-control-next" href="#wantToCarousel" role="button" data-slide="next">
                       
                        <img src="../../../assets/images/arrow-right.png" alt="" width="10" height="15">
                    </a>
                </div>
            </div>
        </div>
    </div>
    <div class="col-md-6">
        <div class="card carousel-card" style="margin-left: auto;">
            <div class="card-body">
                <h3 class="card-title">I'm searching for...</h3>
            </div>
            <div id="lookingForCarousel" class="carousel slide pointer-event" data-ride="carousel"
                data-interval="false">
                <div class="carousel-inner">


                    <ng-container *ngFor="let service of service_chunk; let i = index">
                        <div [ngClass]="i===0 ? 'carousel-item active' : 'carousel-item'">
                            <ul class="list-group list-group-flush">
                                <li class="list-group-item" *ngFor="let item of service; let j = index">
                                    <ng-container *ngIf="item.link_url.indexOf('/')==0">
                                        <a [routerLink]="[item.link_url]" [ngClass]="j===0 ? 'active' : ''"
                                            >
                                            <img [src]="item.icon_image" alt="">{{item.link_name}}
                                        </a>
                                    </ng-container>
                                    <ng-container *ngIf="item.link_url.indexOf('/')!=0">
                                        <a href="{{item.link_url}}" [ngClass]="j===0 ? 'active' : ''"
                                            >
                                            <img [src]="item.icon_image" alt="">{{item.link_name}}
                                        </a>
                                    </ng-container>
                                </li>
                            </ul>
                        </div>
                    </ng-container>
                </div>
                <div class="carosel-arrows">
                    <a class="carousel-control-prev" href="#lookingForCarousel" role="button" data-slide="prev">
                        <!-- <span class="carousel-control-prev-icon" aria-hidden="true"></span>
                             <span class="sr-only">Previous</span> -->
                        <img src="../../assets/images/arrow-left.png" alt="" width="10" height="15">
                    </a>
                    <a class="carousel-control-next" href="#lookingForCarousel" role="button" data-slide="next">
                        <!-- <span class="carousel-control-next-icon" aria-hidden="true"></span>
                             <span class="sr-only">Next</span> -->
                        <img src="../../assets/images/arrow-right.png" alt="" width="10" height="15">
                    </a>
                </div>
            </div>
        </div>
    </div>
</div>